import { bio, site } from "../data/content";
import ExperienceTimeline from "../components/ExperienceTimeline";
import Certifications from "../components/Certifications";
import Testimonials from "../components/Testimonials";
import { Mail, Linkedin, FileDown } from "lucide-react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="pt-28">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24">
        <div className="overline">About</div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-4 leading-[1.02] max-w-4xl" style={{ color: "var(--primary)" }}>
          I move Gigawatts from proposal <span style={{ color: "var(--accent)", fontStyle: "italic" }}>to operation</span>.
        </h1>

        <div className="mt-14 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-8 space-y-7 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            {bio.long.map((para, i) => (
              <p key={i} data-testid={`bio-para-${i}`}>{para}</p>
            ))}
            <div className="pt-2">
              <Link
                to="/cv"
                data-testid="about-cv-cta"
                className="inline-flex items-center gap-2 px-5 py-3 text-sm"
                style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}
              >
                <FileDown size={14} /> Download CV
              </Link>
            </div>
          </div>
          <aside className="md:col-span-4 p-8" style={{ backgroundColor: "var(--surface)", border: "1px solid var(--border-soft)" }}>
            <div className="overline">Quick facts</div>
            <dl className="mt-5 space-y-4 text-sm">
              <Fact k="Based" v="India · Global remote" />
              <Fact k="Career bases" v="India → Malaysia → Japan → India" />
              <Fact k="Languages" v="English, Hindi" />
              <Fact k="Education" v="B.Tech NIT Raipur · HBS CORE" />
              <Fact k="Industries" v="Mining, Aluminium, Copper, Zinc, Steel, Cement, Oil & Gas, Infrastructure" />
              <Fact k="Tech stack" v="PV · Wind · BESS · PSH · Hybrid · Energy Markets" />
            </dl>
            <div className="mt-8 space-y-3">
              <a href={`mailto:${site.email}`} data-testid="about-email" className="flex items-center gap-2 text-sm link-underline">
                <Mail size={14} /> {site.email}
              </a>
              <a href={site.linkedin} target="_blank" rel="noopener noreferrer" data-testid="about-linkedin" className="flex items-center gap-2 text-sm link-underline">
                <Linkedin size={14} /> LinkedIn
              </a>
            </div>
          </aside>
        </div>
      </section>

      <ExperienceTimeline />
      <Certifications />
      <Testimonials />
    </div>
  );
}

function Fact({ k, v }) {
  return (
    <div className="grid grid-cols-3 gap-3">
      <dt className="col-span-1 font-mono text-[10px] font-semibold uppercase tracking-widest pt-1" style={{ color: "var(--text-secondary)" }}>{k}</dt>
      <dd className="col-span-2" style={{ color: "var(--text-primary)" }}>{v}</dd>
    </div>
  );
}
